import { useIsMobile } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { useNavigate } from 'react-router-dom'
import useHomeSitemodels from 'site/shared/hooks/useHomeSitemodels'
import Unauthorized from '../UnauthorizedContainer/Unauthorized'
import AccessRestrictionDesktop from './assets/access-restriction-desktop.png'
import AccessResitrctionMobile from './assets/access-restriction-mobile.png'

const AccessRestriction = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { homeSitemodels } = useHomeSitemodels(true)

  const isMobile = useIsMobile()

  const onNavigateToHomeSitemodel = () => {
    navigate({
      pathname: `/${homeSitemodels?.[0]?.uuid}`
    })
  }

  return (
    <Unauthorized
      des={t('access-restriction.des')}
      complement={t('access-restriction.complement')}
      action={t('access-restriction.action')}
      imageAlt={t('access-restriction.alt')}
      disabled={!homeSitemodels?.[0]?.uuid}
      actionCallback={onNavigateToHomeSitemodel}
      imageSrc={isMobile ? AccessResitrctionMobile : AccessRestrictionDesktop}
    />
  )
}

export default AccessRestriction
